import { getConfig } from '../config/environments';

type DataLayer = Record<string, unknown>[];

function getDataLayer(): DataLayer | null {
  if (typeof window === 'undefined') return null;
  if (!getConfig().enableAnalytics) return null;
  const dl = (window as unknown as { dataLayer?: DataLayer }).dataLayer;
  return Array.isArray(dl) ? dl : null;
}

// `donatePlacement` is always written (null when absent): GTM merges dataLayer keys
// across pushes, so omitting it would inherit the previous push's placement.
export function donateEvent(action: string, placement: string | null = null): void {
  const dl = getDataLayer();
  if (!dl) return;
  dl.push({ event: 'donate', eventAction: action, donatePlacement: placement });
}

export function pageViewEvent(path: string, title?: string): void {
  const dl = getDataLayer();
  if (!dl) return;
  dl.push({
    event: 'PageRendered',
    page_path: path,
    page_title: title ?? (typeof document !== 'undefined' ? document.title : undefined),
    page_location: typeof window !== 'undefined' ? window.location.href : undefined,
  });
}

export function purchaseEvent(transactionId: string, value: number, placement: string | null = null): void {
  const dl = getDataLayer();
  if (!dl) return;
  dl.push({ ecommerce: null });
  dl.push({
    event: 'purchase',
    donatePlacement: placement,
    ecommerce: {
      transaction_id: transactionId,
      value,
      tax: 0,
      shipping: 0,
      currency: 'USD',
    },
  });
}
